import * as React from 'react';


const AdminView: React.FC<{}> = ({}) => {

  return <div>AdminView</div>;
}

export default AdminView;